import styled from '@emotion/styled';

import {mixinFlexboxColumn} from '@ELib/styles/mixins';

export const FlexColumnWrapper = styled.div`
  ${mixinFlexboxColumn}
  flex-wrap: wrap;
  margin-bottom: var(--focus-border-width);

  .MuiFormHelperText-root {
    white-space: pre-line;
    margin-left: 0;
    margin-right: 0;
  }

  .bottomText {
    margin-top: var(--gutter-tiny);
  }
`;
